function underscoreFormatter(value) {
  return value.replace(/_/g, ' ');
}

export default underscoreFormatter;
